import $ from 'jquery';
import ChartModel from '@/data/models/chart';
import WidgetView from '@/data/views/widget';

window.ChartModel = ChartModel;

$(document).ready(function() {
  new WidgetView();
});
